module.exports = __webpack_public_path__ + "img/006-panda.7531ded0.svg";